import { useState } from "react";
import { ChecklistStep } from "../../components/widgets/ProgressBar";
import StatusToggle from "../../components/forms/StatusToggle";
import NotesField from "../../components/forms/NotesField";
import { useStore } from "../../js/state/store";

export const TRANSACTION_ITEMS = [
  {
    id: "preapproval",
    title: "Pre-approval",
    detail: "Meet a lender, share income and debts, and get a written pre-approval letter before you tour seriously.",
  },
  {
    id: "loan-type",
    title: "Loan type selection",
    detail: "Choose conventional, FHA, VA, USDA, jumbo, or cash. Confirm how that choice affects down payment and mortgage insurance.",
  },
  {
    id: "down-payment",
    title: "Down payment planning",
    detail: "Know the source of funds, gift letters if needed, and how much cash you still need for closing costs and reserves.",
  },
  {
    id: "escrow",
    title: "Escrow opening",
    detail: "After acceptance, escrow opens, earnest money is deposited, and timelines (inspection, loan, close) start running.",
  },
  {
    id: "appraisal",
    title: "Appraisal scheduling",
    detail: "The lender orders the appraisal. Be ready with comps context from your agent if value looks tight.",
  },
  {
    id: "inspections",
    title: "Inspections",
    detail: "Schedule general inspection quickly, then specialists as recommended. Calendar the objection deadline.",
  },
  {
    id: "repairs",
    title: "Repair requests",
    detail: "Decide repair vs. credit vs. walk. Put requests in writing through your agent before the deadline.",
  },
  {
    id: "disclosures",
    title: "Closing disclosures",
    detail: "Review the Closing Disclosure at least three business days before closing. Check fees, rate, and cash to close.",
  },
  {
    id: "walkthrough",
    title: "Final walkthrough",
    detail: "Confirm agreed repairs, systems on, and the home is in the condition you contracted for — usually the day of or before close.",
  },
];

export default function BuyerTransactionChecklist() {
  const saved = useStore().state.buyer.current.preferences.transactionChecklist || {};
  const [form, setForm] = useState({
    statuses: saved.statuses || {},
    notes: saved.notes || "",
  });

  function setStatus(id, value) {
    setForm((current) => ({
      ...current,
      statuses: { ...current.statuses, [id]: value },
    }));
  }

  return (
    <ChecklistStep
      title="Handy Transaction Checklist"
      lead="No need to keep this in your head. Use it! 😊 Track financing through closing — Complete, In Progress, or Needs Attention."
      preferenceKey="transactionChecklist"
      value={form}
    >
      {TRANSACTION_ITEMS.map((item) => (
        <article key={item.id} className="txn-item">
          <h3>{item.title}</h3>
          <p className="muted">{item.detail}</p>
          <StatusToggle
            name={item.id}
            value={form.statuses[item.id] || ""}
            onChange={(event) => setStatus(item.id, event.target.value)}
          />
        </article>
      ))}
      <NotesField
        label="Transaction notes for my agent"
        name="notes"
        value={form.notes}
        onChange={(event) => setForm((current) => ({ ...current, notes: event.target.value }))}
        placeholder="Lender name, deadlines you are worried about, or questions before the next milestone."
      />
    </ChecklistStep>
  );
}
